var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"version-details"},[(_vm.computedAppName && _vm.computedAppCode)?_c('IntrosForAppsList',{attrs:{"title":("Feature intro in " + _vm.computedAppName + " app"),"app-code":_vm.computedAppCode}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }